import { render, staticRenderFns } from "./accessories_in_price.vue?vue&type=template&id=8794596a&"
import script from "./accessories_in_price.vue?vue&type=script&lang=js&"
export * from "./accessories_in_price.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports